// v2.19.34 — Page React de partage d'une adresse nommée.
// Route /a/:slugSuffix — fetch /api/v3/addresses/by-slug/:slugSuffix → affiche le claim.
import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export default function SharedAddressPage() {
  const { slugSuffix } = useParams();
  const [claim, setClaim] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await fetch(`${API}/v3/addresses/by-slug/${encodeURIComponent(slugSuffix)}`);
        const d = await r.json();
        if (r.ok && d.ok) setClaim(d.claim);
        else setError(d.error || `HTTP ${r.status}`);
      } catch (_) { setError("network_error"); }
      finally { setLoading(false); }
    })();
  }, [slugSuffix]);

  if (loading) return <div style={pageStyle}><div style={{ color: "#94A3B8" }}>Chargement…</div></div>;
  if (error || !claim) {
    return (
      <div style={pageStyle}>
        <div style={cardStyle}>
          <h1 style={{ color: "#F87171", fontSize: 22 }}>
            {error === "private_claim" ? "🔒 Adresse privée" : "Adresse introuvable"}
          </h1>
          <p style={{ color: "#94A3B8", marginTop: 12 }}>
            {error === "private_claim"
              ? "Le propriétaire de cette adresse a choisi de la garder privée."
              : "Ce lien ne pointe vers aucune adresse AYA AI active."}
          </p>
          <Link to="/" data-testid="share-back-home" style={ctaAltStyle}>← Retour à AYA AI</Link>
        </div>
      </div>
    );
  }

  const mapsUrl = `https://maps.google.com/?q=${claim.lat},${claim.lng}`;
  const copyCode = async () => {
    try { await navigator.clipboard.writeText(claim.address_civ); } catch (_) {}
  };

  return (
    <div style={pageStyle} data-testid="shared-address-page">
      <div style={cardStyle}>
        {claim.claim_photo_url && (
          <img src={claim.claim_photo_url} alt={claim.friendly_name} style={photoStyle} data-testid="shared-photo" />
        )}
        <h1 style={{ color: "#FBBF24", fontSize: 28, marginBottom: 6 }} data-testid="shared-name">{claim.friendly_name}</h1>
        <div style={codeBoxStyle} data-testid="shared-code">{claim.address_civ}</div>
        <div style={{ fontSize: 13, color: "#94A3B8", margin: "10px 0 22px" }}>
          📍 {claim.commune_name || claim.district_name}, Côte d'Ivoire
          {claim.popularity_score > 0 && <> · 🔥 {claim.popularity_score} vues</>}
        </div>
        <a href={mapsUrl} target="_blank" rel="noopener noreferrer" data-testid="shared-maps-btn" style={ctaStyle}>🗺 Itinéraire</a>
        <button onClick={copyCode} data-testid="shared-copy-btn" style={ctaAltStyle}>📋 Copier le code</button>
        <Link to="/" data-testid="shared-aya-link" style={{ ...ctaAltStyle, marginTop: 8 }}>Ouvrir AYA AI</Link>
        <div style={{ textAlign: "center", marginTop: 22, color: "#64748b", fontSize: 11 }}>Adresse partagée via AYA AI 🇨🇮</div>
      </div>
    </div>
  );
}

const pageStyle = { minHeight: "100vh", padding: 24, background: "radial-gradient(ellipse at top, #14223D 0%, #0A0F1F 70%)", color: "#E8ECF7", fontFamily: "system-ui, sans-serif", display: "flex", justifyContent: "center", alignItems: "flex-start" };
const cardStyle = { maxWidth: 540, width: "100%", margin: "40px auto", background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.10)", borderRadius: 16, padding: 28 };
const photoStyle = { width: "100%", borderRadius: 12, marginBottom: 18, maxHeight: 280, objectFit: "cover" };
const codeBoxStyle = { fontFamily: "monospace", letterSpacing: 1, color: "#93C5FD", fontWeight: 700, fontSize: 14, background: "rgba(59,130,246,0.12)", padding: "6px 12px", borderRadius: 8, display: "inline-block" };
const ctaStyle = { display: "block", textAlign: "center", marginTop: 8, background: "#16A34A", color: "#fff", textDecoration: "none", fontWeight: 700, fontSize: 14, padding: "12px 22px", borderRadius: 10, boxShadow: "0 4px 14px rgba(22,163,74,0.35)" };
const ctaAltStyle = { display: "block", textAlign: "center", marginTop: 8, background: "rgba(255,255,255,0.06)", color: "#E8ECF7", textDecoration: "none", fontWeight: 600, fontSize: 13, padding: "10px 18px", borderRadius: 10, border: "1px solid rgba(255,255,255,0.12)", cursor: "pointer", fontFamily: "inherit", width: "100%" };
